import api from './api';

export interface MetricLevel {
    id: number;
    name: string;
    display_label: string;
    is_period_based: boolean;
    description?: string | null;
    created_by?: string | number;
    updated_by?: string | number;
    created_at?: string | null;
    updated_at?: string | null;
}

export const getAllMetricLevels = (): Promise<MetricLevel[]> => {
    return api.get('/metric_levels').then(response => response.data);
};

export const createMetricLevel = (metricLevel: {
    name: string;
    display_label: string;
    is_period_based: boolean;
    description?: string | null;
}): Promise<number> => {
    return api.post('/metric_level', metricLevel).then(response => response.data);
};

export const updateMetricLevel = (metricLevel: {
    name: string;
    display_label: string;
    is_period_based: boolean;
    description?: string | null;
}): Promise<string> => {
    return api.put('/metric_level', metricLevel).then(response => response.data);
};

export const deleteMetricLevel = (name: string): Promise<string> => {
    return api.delete(`/metric_level/${encodeURIComponent(name)}`).then(response => response.data);
};
